import { Trans } from '@lingui/react'

import Price from 'views/components/atoms/Price'

// @ts-ignore
const SubTotal = ({ productAmount, currency }) => (
  <div className="u-margin-small--bottom l-flex l-flex--distribute-space o-CartSumBox__list-item">
    <strong className="o-CartSumBox__list-item-label">
      <Trans id="general.label.subTotal" />
    </strong>
    <strong>
      <Price
        amount={productAmount}
        currency={currency}
        dataQa="cart-sumBox-subTotal"
      />
    </strong>
  </div>
)

export default SubTotal
